module.exports = __webpack_public_path__ + "static/media/product_6_BU1216.0001dd9a.jpg";